import Vue from 'vue'
import Vuex from 'vuex'

//import shidian from './modules/shidian'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    //shidian
  }
})
